import React from 'react'
import { l } from '@manychat/manyui'

const FBRecurringNotificationsRestoredNotification = () => {
  return (
    <>
      <span className="m-r-xxs">
        {l.translate(`Facebook Recurring Notifications has been restored for your account.`)}
      </span>
    </>
  )
}

export default FBRecurringNotificationsRestoredNotification
